'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUILozenge = function AUILozenge(_ref) {
    var type = _ref.type,
        subtle = _ref.subtle,
        children = _ref.children;

    var classes = (0, _classnames2.default)('aui-lozenge', 'aui-lozenge-' + type, {
        'aui-lozenge-subtle': subtle
    });

    return _react2.default.createElement(
        'span',
        { className: classes },
        children
    );
};

AUILozenge.displayName = 'AUILozenge';
AUILozenge.propTypes = {
    type: _propTypes2.default.oneOf(['success', 'error', 'current', 'new', 'moved']),
    subtle: _propTypes2.default.bool,
    children: _propTypes2.default.string
};

exports.default = AUILozenge;
//# sourceMappingURL=AUILozenge.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUILozenge.js
// module id = 188
// module chunks = 0